// Prioritization Indices
// API related actions
export const FETCHING_PRIORITIZATION_INDICES = '@@toyota/FETCHING_PRIORITIZATION_INDICES';
export const FETCHED_PRIORITIZATION_INDICES = '@@toyota/FETCHED_PRIORITIZATION_INDICES';
export const FETCHED_PRIORITIZATION_INDICES_FAILED = '@@toyota/FETCHED_PRIORITIZATION_INDICES_FAILED';
export const DOWNLOADING_PRIORITIZATION_INDICES = '@@toyota/DOWNLOADING_PRIORITIZATION_INDICES';
export const DOWNLOADED_PRIORITIZATION_INDICES = '@@toyota/DOWNLOADED_PRIORITIZATION_INDICES';
export const DOWNLOADED_PRIORITIZATION_INDICES_FAILED = '@@toyota/DOWNLOADED_PRIORITIZATION_INDICES_FAILED';

// complementary actions
export const CLEAR_PRIORITIZATION_INDICES = '@@toyota/CLEAR_PRIORITIZATION_INDICES';
export const CHANGE_PRIORITIZATION_INDICES_LIST_PAGE = '@@toyota/CHANGE_PRIORITIZATION_INDICES_LIST_PAGE';
export const CHANGE_PRIORITIZATION_INDICES_LIST_PAGE_SIZE = '@@toyota/CHANGE_PRIORITIZATION_INDICES_LIST_PAGE_SIZE';

// logistic actions
export const FETCHING_LOGISTIC_INDICES = '@@toyota/FETCHING_LOGISTIC_INDICES';
export const FETCHED_LOGISTIC_INDICES = '@@toyota/FETCHED_LOGISTIC_INDICES';
export const FETCHED_LOGISTIC_INDICES_FAILED = '@@toyota/FETCHED_LOGISTIC_INDICES_FAILED';

export const FETCHING_LOGISTIC_INDICES_DETAIL = '@@toyota/FETCHING_LOGISTIC_INDICES_DETAIL';
export const FETCHED_LOGISTIC_INDICES_DETAIL = '@@toyota/FETCHED_LOGISTIC_INDICES_DETAIL';
export const FETCHED_LOGISTIC_INDICES_DETAIL_FAILED = '@@toyota/FETCHED_LOGISTIC_INDICES_DETAIL_FAILED';

export const DOWNLOAD_LOGISTIC_INDICES_DETAILL_REQUEST = '@@toyota/DOWNLOAD_LOGISTIC_INDICES_DETAILL_REQUEST';
export const DOWNLOAD_LOGISTIC_INDICES_DETAIL_SUCCESS = '@@toyota/DOWNLOAD_LOGISTIC_INDICES_DETAIL_SUCCESS';
export const DOWNLOAD_LOGISTIC_INDICES_DETAIL_FAILED = '@@toyota/DOWNLOAD_LOGISTIC_INDICES_DETAIL_FAILED';

export const CLEAR_LOGISTIC_INDICES = '@@toyota/CLEAR_LOGISTIC_INDICES';
export const CLEAR_LOGISTIC_INDICES_DETAIL_EXCEL_FILE = '@@toyota/CLEAR_LOGISTIC_INDICES_DETAIL_EXCEL_FILE';
